const { wrapHOC } = require('utils/framework/wrapHOC');
const { wrapHOCComponent } = require('utils/framework/wrapHOCComponent');
const wrapUFE = require('utils/framework/wrapUFE');
const wrapUFEFunctional = require('utils/framework/wrapUFEFunctional');


module.exports = {
    wrapComponent: (component, name, hasCtrlr) => {
        component.class = name;
        const modifiedComponent = wrapUFE(component, hasCtrlr);

        return modifiedComponent;
    },
    wrapFunctionalComponent: wrapUFEFunctional,
    wrapHOC,
    wrapHOCComponent
};
